import React from "react";
import { Theme } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import makeStyles from "@material-ui/core/styles/makeStyles";
import LabeledContent from "../../../components/LabeledContent";
import { IPrivateClassListItemFrontEndModel } from "../types";
import { ActionBar } from "../../../components/ActionBar/ActionBar";
import { useWizard } from "../../wizard/context";
import { usePrivateClassConfig } from "../modals/hooks/usePrivateClassConfig";
import { QUERY_KEYS } from "../../../constants";
import { queryCache, useQuery } from "react-query";
import usePrivateClassQueries from "../hooks/usePrivateClassQueries";
import langs from "langs";

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    padding: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      borderBottom: "1px solid #dfdcd6",
    },
  },
  container: {
    marginTop: "-12px",
    marginBottom: "-12px",
    marginLeft: "-8px",
  },
  buttonsContainer: {
    display: "flex",
    textAlign: "center",
    justifyContent: "space-between",
    alignSelf: "center",
  },
  paper: {
    padding: 25,
  },
}));

export default function PrivateClassListItem({
  privateClass,
}: {
  privateClass: IPrivateClassListItemFrontEndModel;
}) {
  const classes = useStyles();

  const { getPrivateClassSubjectList } = usePrivateClassQueries();
  const { privateClassSubjects } = QUERY_KEYS;

  const { data: subjectsData } = useQuery<any>(
    [privateClassSubjects],
    () => getPrivateClassSubjectList(),
  );

  const subjectName =
    subjectsData?.data?.find((s) => s.id === privateClass.subjectId)?.name ?? "";

  const teachingLanguageName =
    langs.where("3", privateClass.teachingLanguage)?.name ?? privateClass.teachingLanguage;

  const { openWizard } = useWizard();
  const { getViewConfig, getEditConfig, getDeleteConfig } =
    usePrivateClassConfig();

  const { privateClassListForTeacher } = QUERY_KEYS;

  const viewPrivateClass = async () => {
    openWizard(getViewConfig(privateClass.id));
  };

  const editPrivateClass = async () => {
    if (await openWizard(getEditConfig(privateClass.id))) {
      await queryCache.invalidateQueries([privateClassListForTeacher]);
    }
  };

  const deletePrivateClass = async () => {
    if (await openWizard(getDeleteConfig(privateClass.id))) {
      await queryCache.invalidateQueries([privateClassListForTeacher]);
    }
  };

  return (
    <Grid item xs={12} style={{ paddingBottom: 4 }}>
      <Paper className={classes.paper}>
        <Grid
          container
          spacing={2}
          justify={"space-between"}
          alignItems={"flex-start"}
        >
          <Grid item xs={12} sm={10}>
            <Grid container spacing={2} className={classes.container}>
              <Grid item xs={12} sm={6} md={4} className={classes.content}>
                <LabeledContent label={"Subject Name"}>
                  {subjectName}
                </LabeledContent>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className={classes.content}>
                <LabeledContent label={"Teaching Language"}>
                  {teachingLanguageName}
                </LabeledContent>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={"auto"}
            className={classes.buttonsContainer}
          >
            <div>
              <ActionBar
                editCallBack={editPrivateClass}
                editTooltip={"Edit private class"}
                viewCallBack={viewPrivateClass}
                viewTooltip={"View private class"}
                deleteCallBack={deletePrivateClass}
                deleteTooltip={"Delete private class"}
              />
            </div>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}
